module.exports = __webpack_public_path__ + "img/logo.38de9d65.png";